import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges
} from '@angular/core';
import { FilterService } from '@core/services/filter/filter.service';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { LoadingDotsComponent } from '@shared/loading-dots/loading-dots.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-load-more',
    templateUrl: './load-more.component.html',
    styleUrls: ['./load-more.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, LoadingDotsComponent, TranslateSafePipe]
})
export class LoadMoreComponent implements OnChanges {
    public href = '';

    @Input()
    public readonly pending?: boolean | null;

    @Input()
    public readonly current?: number;

    @Input()
    public readonly total?: number;

    @Output()
    public readonly loadMore: EventEmitter<void> = new EventEmitter();

    constructor(private filterService: FilterService) {}

    ngOnChanges(changes: SimpleChanges): void {
        const { current } = changes;

        if (current && current.currentValue !== current.previousValue) {
            this.href = this.filterService.constructFilterUrl({
                take: changes.current.currentValue + this.filterService.defaultTakeAmount,
                from: 0
            });
        }
    }

    public onClick(event: MouseEvent): void {
        event.preventDefault();
        this.loadMore.emit();
    }
}
